import cn from 'classnames';
import React from 'react';
import RadioList from 'app/ui/form/RadioList/RadioList';
import './ConfirmRCARadioList.scss';

export default function ConfirmAuthorRolesCheckboxList({ className, ...props }) {
    return <RadioList className={cn('ConfirmRCARadioList', className)} {...props} />;
}
